import { createGetAllPaginatedItems } from "@edgetier/utilities";
import axios from "./axios";

/**
 * Get all items for a paginated URL.
 * @param url URL to request.
 */
export const getAllPaginatedItems = createGetAllPaginatedItems(axios);
